<template>
  <div class="evento-container">


    <div class="linea-division" ref="lineaCentral"></div>

    <div class="evento-card" ref="card2">
      <img src="@/assets/8.png" alt="Ceremonia Civil" class="evento-icono" />
      <p class="evento-titulo"> Celebración</p>
      <p class="evento-fecha">Sábado 13 de Diciembre</p>
      <p class="evento-lugar">Centro Cívico 

  </p>
                  <p class="evento-direccion"> Carr. Guadalupe Victoria, Zona Centro,  Santander Jiménez, Tamaulipas 
</p>

      <p class="evento-hora">5:30 P.M.</p>
      <a href="https://maps.app.goo.gl/kKYNDxRQwXxPhiMX6" class="btn-mapa" target="_blank">VER MAPA</a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'EventoSection',
  setup() {
    const card2 = ref(null)
    const lineaCentral = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              
              if (entry.target === lineaCentral.value) {
                gsap.fromTo(lineaCentral.value, { scaleY: 0 }, { scaleY: 1, transformOrigin: 'top', duration: 0.8 })
              }
              if (entry.target === card2.value) {
                gsap.fromTo(card2.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.2, delay: 0.3 })
              }
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.4 }
      )

      observer.observe(lineaCentral.value)
      observer.observe(card2.value)
    })

    return {  card2, lineaCentral }
  }
}
</script>

<style scoped>
.evento-container {
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #121111;
}

.evento-card {
  text-align: center;
  margin-bottom: 50px;
  max-width: 300px;
  opacity: 0;
}

.evento-icono {
  width: 58px;
  margin-bottom: 12px;
}

.evento-icono1 {
  width: 78px;
  margin-bottom: 12px;
}


.evento-titulo {
  font-family: 'Corinthia', cursive;
  font-size: 33px;
  color: #121111;
  margin: 0 0 6px;
}

.evento-fecha {
  font-family: 'padres', serif;
  font-size: 14px;
  color: #121111;
  margin-bottom: 6px;
}

.evento-lugar {
  font-family: 'padres', serif;
  font-size: 15px;
  font-weight: bold;
  color: #121111;
  margin-bottom: 6px;
}

.evento-direccion {
  font-family: 'padres', serif;
  font-size: 12px;
  color: #121111;
  margin-bottom: 6px;
}
.evento-hora {
  font-family: 'fa', sans-serif;
  font-size: 13px;
  color: #121111;
  font-style: italic;
  margin-bottom: 12px;
}

.btn-mapa {
  background: transparent;
  border: 1px solid #292929;
  color: #1c1b1b;
  font-size: 13px;
  padding: 6px 18px;
  text-decoration: none;
  font-family: 'padres', serif;
  letter-spacing: 1px;
  transition: all 0.3s ease;
}

.btn-mapa:hover {
  background: #fff;
  color: #111;
}

.linea-division {
  width: 2px;
  height: 40px;
  background: #fff;
  margin: 20px 0;
  transform: scaleY(0);
}
</style>
